import { render, staticRenderFns } from "./KanbanNew.vue?vue&type=template&id=8bc29488&scoped=true"
import script from "./KanbanNew.vue?vue&type=script&scoped=true&lang=js"
export * from "./KanbanNew.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./KanbanNew.vue?vue&type=style&index=0&id=8bc29488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc29488",
  null
  
)

export default component.exports